<template>
  <div>
    <section-title has-line title="Información de Pagos" />
    <div class="row mb-3">
      <div class="col">
        <payment-info-filter
          :periods="catalog.periods"
          :regions="catalog.regions"
          :services="catalog.services"
          @on-search="onSearchHandler"
        />
      </div>
    </div>
    <div class="row">
      <div class="col" :class="{ 'hide-tab-header': hideTabs }">
        <custom-tab
          v-model="tabIndex"
          class="custom-tab-extended"
          @input="onTabChanged"
        >
          <custom-tab-item active lazy :title="pendingTabTitle">
            <custom-result-not-found v-if="pendingService.data.length == 0" />
            <div
              v-if="pendingService.data.length > 0"
              class="d-flex justify-content-end align-items-center my-3"
            >
              <span class="color-green font-16 font-weight-normal pt-1">
                Seleccionar Todos
              </span>
              <check-box v-model="checkedPending" class="w-auto ml-2" />
            </div>
            <div
              v-for="(item, index) in pendingService.data"
              :key="`pending-service-item-${index}`"
              class="my-2"
            >
              <payment-info-row
                :index="index"
                :journal-status="value.paymentJournalStatusId"
                :value="item"
                @on-denegate-item="onDenegateHandler"
                @on-open-additional-section="onOpenAdditionalSection(0, $event)"
                @on-open-deny-section="onOpenAdditionalSection(0, $event)"
                @on-open-general-additional-section="
                  onOpenGeneralAdditionalSection(0, $event)
                "
              />
              <div
                v-if="item.isNotEligible"
                class="bg-secondary-18 p-2 rounded mt-n3 mb-3"
              >
                <div
                  class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                >
                  <em class="fas fa-bell-exclamation pl-1" />
                  <div class="ml-2 no-eligible-message pl-2">
                    El estudiante no es elegible para Becas de Transportación de
                    acuerdo a los PEI’s firmados en el sistema.
                  </div>
                </div>
              </div>
              <div
                v-if="item.notEligiblePayment"
                class="bg-secondary-19 p-2 rounded mt-n3 mb-3"
              >
                <div
                  class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                >
                  <em class="fa fa-times-circle color-secondary-20 mr-2" />
                  <div class="color-secondary-20 font-14 font-weight-normal">
                    No es posible aprobar los pagos, ya que cuenta con
                    estudiante(s) no elegible(s) para Becas de Transportación de
                    acuerdo a los PEI’s firmados en el sistema.
                  </div>
                </div>
              </div>
            </div>
            <pagination
              v-if="pendingService.totalItemCount > pageSize"
              :data="pendingService"
              :page-size="pageSize"
              @pagination-go-page="onChangePendingPage"
            />
          </custom-tab-item>
          <custom-tab-item :active="hideTabs" lazy :title="processedTabTitle">
            <custom-result-not-found v-if="processedService.data.length == 0" />
            <div
              v-if="processedService.data.length > 0"
              class="d-flex justify-content-end align-items-center my-3"
            >
              <span class="color-green font-16 font-weight-normal pt-1">
                Seleccionar Todos
              </span>
              <check-box v-model="checkedProcessed" class="w-auto ml-2" />
            </div>
            <div
              v-for="(item, index) in processedService.data"
              :key="`processed-service-item-${index}`"
              class="my-2"
            >
              <payment-info-row
                :index="index"
                :journal-status="value.paymentJournalStatusId"
                :value="item"
                @on-denegate-item="onDenegateHandler"
                @on-open-additional-section="onOpenAdditionalSection(1, $event)"
                @on-open-deny-section="onOpenAdditionalSection(1, $event)"
                @on-open-general-additional-section="
                  onOpenGeneralAdditionalSection(1, $event)
                "
              />
              <div
                v-if="item.isNotEligible"
                class="bg-secondary-18 p-2 rounded mt-n3 mb-3"
              >
                <div
                  class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                >
                  <em class="fas fa-bell-exclamation pl-1" />
                  <div class="ml-2 no-eligible-message pl-2">
                    El estudiante no es elegible para Becas de Transportación de
                    acuerdo a los PEI’s firmados en el sistema.
                  </div>
                </div>
              </div>
            </div>
            <pagination
              v-if="processedService.totalItemCount > pageSize"
              :data="processedService"
              :page-size="pageSize"
              @pagination-go-page="onChangeProcessedPage"
            />
          </custom-tab-item>
        </custom-tab>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import CheckBox from 'CheckBox';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import PaymentInfoRow from './PaymentInfoRow';
import PaymentInfoFilter from './PaymentInfoFilter';
import { getPaymentJournalDetailData as _getPaymentJournalDetailData } from '@/modules/shared/scholarship.api.js';
import { getDisciplineTypesSplit as _getDisciplineTypesSplit } from '@/modules/shared/code.api.js';
import { getPeriodsByFiscalYears as _getPeriodsByFiscalYear } from '@/modules/shared/academicyear.api';
import { getRegions as _getRegions } from '@/modules/shared/location.api';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus';

const DEFAULT_PAGE_SIZE = 15;

export default {
  name: 'PaymentInfo',
  components: {
    SectionTitle,
    Pagination,
    CustomResultNotFound,
    CheckBox,
    CustomTab,
    CustomTabItem,
    PaymentInfoRow,
    PaymentInfoFilter,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      paymentJournalId: null,
      catalog: {
        services: [],
        periods: [],
        regions: [],
      },
      pendingService: {
        data: [],
        totalItemCount: 0,
      },
      processedService: {
        data: [],
        totalItemCount: 0,
      },
      checkedPending: false,
      checkedProcessed: false,
      tabIndex: 0,
      selectedFilter: {},
    };
  },
  computed: {
    pendingTabTitle() {
      return `Pendientes (${this.pendingService.totalItemCount})`;
    },
    processedTabTitle() {
      return `Procesados (${this.processedService.totalItemCount})`;
    },
    isSIE() {
      return (value) => value?.length <= 8 ?? null;
    },
    isSSN() {
      return (value) => value?.length > 8 ?? null;
    },
    getFilterParams() {
      return {
        serviceId: this.selectedFilter.service?.id,
        monthId: this.selectedFilter.period?.id,
        regionId: this.selectedFilter.region?.id,
        studentSieId: this.isSIE(this.selectedFilter.ssnorsie)
          ? this.selectedFilter.ssnorsie
          : null,
        studentSsn: this.isSSN(this.selectedFilter.ssnorsie)
          ? this.selectedFilter.ssnorsie
          : null,
      };
    },
    isProcessed() {
      return (
        this.value.paymentJournalStatusId === paymentJournalStatus.Procesado
      );
    },
    hideTabs() {
      return this.value.paymentJournalStatusId != paymentJournalStatus.Nuevo;
    },
    pageSize() {
      return DEFAULT_PAGE_SIZE;
    },
  },
  watch: {
    checkedPending(value) {
      this.pendingService = {
        ...this.pendingService,
        data: this.pendingService.data.map((item) => {
          item.isChecked = value;
          return item;
        }),
      };
    },
    checkedProcessed(value) {
      this.processedService = {
        ...this.processedService,
        data: this.processedService.data.map((item) => {
          item.isChecked = value;
          return item;
        }),
      };
    },
    'pendingService.data': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$emit('items-checked', [...this.getCheckedItems()]);
        }
      },
    },
    'processedService.data': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$emit('items-checked', [...this.getProcessedCheckedItems()]);
        }
      },
    },
  },
  async mounted() {
    const { academicYearId, paymentJournalId } = this.$route.params;
    if (paymentJournalId) {
      this.paymentJournalId = paymentJournalId;
      await this.callPendingPaymentDetail();
      await this.callProcessedPaymentDetail();

      if (academicYearId) {
        await this.initFilters(academicYearId);
      }
    }
  },
  methods: {
    onChangePendingPage(page) {
      this.callPendingPaymentDetail(page);
    },
    onChangeProcessedPage(page) {
      this.callProcessedPaymentDetail(page);
    },
    async onSearchHandler(filter) {
      this.selectedFilter = filter;
      if (this.tabIndex === 0) {
        await this.callPendingPaymentDetail();
      } else {
        await this.callProcessedPaymentDetail();
      }
    },
    getCheckedItems() {
      return this.pendingService.data
        .filter((x) => x.isChecked)
        .map((x) => x.assistanceSummaryId);
    },
    getProcessedCheckedItems() {
      return this.processedService.data
        .filter((x) => x.isChecked)
        .map((x) => x.assistanceSummaryId);
    },
    onTabChanged(tabIndex) {
      this.resetChecked();
      this.$emit('on-tab-changed', tabIndex);
    },
    async callPendingPaymentDetail(pageIndex = 1) {
      const { data: response } = await _getPaymentJournalDetailData(
        {
          paymentJournalId: this.paymentJournalId,
          paymentApprovalFlag: '0',
          ...this.getFilterParams,
        },
        pageIndex
      );

      this.pendingService = {
        ...this.pendingService,
        ...response,
        data: response.data.map((x) => ({
          ...x,
          isChecked: false,
          isOpened: false,
          isOpenDenyPayment: false,
        })),
      };
    },
    async callProcessedPaymentDetail(pageIndex = 1) {
      const { data: response } = await _getPaymentJournalDetailData(
        {
          paymentJournalId: this.paymentJournalId,
          paymentApprovalFlag: '1',
          ...this.getFilterParams,
        },
        pageIndex
      );

      this.processedService = {
        ...this.processedService,
        ...response,
        data: response.data.map((x) => ({
          ...x,
          isChecked: false,
          isOpened: false,
          isOpenDenyPayment: false,
        })),
      };
    },
    async initFilters(academicYearId) {
      const { data } = await _getPeriodsByFiscalYear(academicYearId);
      this.catalog.periods = data;

      const { data: responseServices } = await _getDisciplineTypesSplit();
      this.catalog.services = responseServices;

      let parameters = {
        academicYearId: academicYearId,
      };
      const { data: responseRegions } = await _getRegions(parameters);
      this.catalog.regions = responseRegions;
    },
    resetChecked() {
      this.checkedPending = false;
      this.checkedProcessed = false;

      this.pendingService = {
        ...this.pendingService,
        data: this.pendingService.data.map((item) => {
          item.isChecked = false;
          item.isOpened = false;
          item.isOpenDenyPayment = false;
          return item;
        }),
      };
      this.processedService = {
        ...this.processedService,
        data: this.processedService.data.map((item) => {
          item.isChecked = false;
          item.isOpened = false;
          item.isOpenDenyPayment = false;
          return item;
        }),
      };
    },
    async onDenegateHandler(assistanceSummaryId, comment) {
      this.$emit('on-denegate-item', assistanceSummaryId, comment);
    },
    onOpenAdditionalSection(tabIndex, { itemIndex, propName }) {
      if (tabIndex === 0) {
        this.pendingService = {
          ...this.pendingService,
          data: this.pendingService.data.map((item, index) => {
            if (itemIndex == index) {
              item[propName] = !item[propName];
            } else {
              item[propName] = false;
              item.isOpened = false;
            }
            return item;
          }),
        };
      } else {
        this.processedService = {
          ...this.processedService,
          data: this.processedService.data.map((item, index) => {
            if (itemIndex == index) {
              item[propName] = !item[propName];
            } else {
              item[propName] = false;
              item.isOpened = false;
            }
            return item;
          }),
        };
      }
    },
    onOpenGeneralAdditionalSection(tabIndex, { itemIndex, generalTabIndex }) {
      if (tabIndex === 0) {
        this.pendingService = {
          ...this.pendingService,
          data: this.pendingService.data.map((item, index) => {
            if (itemIndex == index) {
              item.mainTabModel = generalTabIndex;
              item.isOpened = true;
            } else {
              item.isOpened = false;
            }
            return item;
          }),
        };
      } else {
        this.processedService = {
          ...this.processedService,
          data: this.processedService.data.map((item, index) => {
            if (itemIndex == index) {
              item.mainTabModel = generalTabIndex;
              item.isOpened = true;
            } else {
              item.isOpened = false;
            }
            return item;
          }),
        };
      }
    },
    validateEliglePayments() {
      this.setNotEligiblePayments();
      return this.pendingService.data.some(
        (s) => s.isChecked && s.isNotEligible
      );
    },
    setNotEligiblePayments() {
      this.pendingService = {
        data: this.pendingService.data.map((x) => {
          x.notEligiblePayment = x.isChecked && x.isNotEligible;
          return x;
        }),
      };
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .hide-tab-header {
  .nav-item {
    display: none !important;
  }
}

@media only screen and (max-width: 768px) {
  .hide-tab-header {
    ::v-deep .custom-tab-extended {
      .nav-item,
      .nav-left-icon,
      .nav-right-icon {
        display: none !important;
      }
    }
  }
}
</style>
